import React, { useState, useEffect, useCallback } from 'react';
import ContactForm from './ContactForm';

const STORAGE_KEY = 'cg_home_contact_modal_dismissed';

const ContactArrivalModal = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(STORAGE_KEY)) return;
    } catch {
      /* ignore */
    }
    const timer = setTimeout(() => setVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  const close = useCallback(() => {
    setVisible(false);
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    if (!visible) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [visible, close]);

  if (!visible) return null;

  return (
    <div
      className="contact-arrival-modal-backdrop"
      role="presentation"
      onClick={close}
    >
      <div
        className="contact-arrival-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-arrival-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="contact-arrival-modal-close"
          onClick={close}
          aria-label="Fermer la fenêtre de contact"
        >
          ×
        </button>
        <div className="contact-arrival-modal-header">
          <h2 id="contact-arrival-modal-title" className="contact-arrival-modal-title">
            Contactez CallGarden
          </h2>
          <p className="contact-arrival-modal-subtitle">
            Une question ou un projet ? Laissez-nous un message, nous vous répondons sous 24h.
          </p>
        </div>
        <div className="contact-arrival-modal-body">
          <ContactForm type="basic" embedded idPrefix="arrival-" />
        </div>
      </div>
    </div>
  );
};

export default ContactArrivalModal;
